import { CSSProperties, forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { StarSubstrateSvg, StarSvg } from "../icons";

import styles from "./styles.module.scss"

export type StarIconColor = "yellow" | "gray";

export type StarIconProps = HTMLAttributes<HTMLDivElement> & {
  fill?: number
  color?: StarIconColor
};

export const StarIcon = memo(forwardRef<HTMLDivElement, StarIconProps>((
  {
    fill = 0,
    color = "yellow",
    children,
    className,
    style,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[`fill-${fill}`],
        styles[color]
      )}
      style={{
        "--fill-width-percentage": fill + "%",
        ...style
      } as CSSProperties}
    >
      <StarSubstrateSvg />
      <i className={styles.star}><StarSvg /></i>
    </div>
  );
}));